export default "__VITE_ASSET__BhTYQpmM__"